import React from "react";
import { SEO } from "./SEO";

interface SearchSEOProps {
  query: string;
  totalResults?: number;
}

/**
 * SearchSEO component for search results pages
 *
 * This adds appropriate metadata for search pages while
 * ensuring they're not indexed by search engines
 */
export const SearchSEO: React.FC<SearchSEOProps> = ({
  query,
  totalResults,
}) => {
  const title = query
    ? `Resultados de búsqueda para: ${query}`
    : "Búsqueda de productos";

  const description = query
    ? `Explora los ${
        totalResults || ""
      } resultados para "${query}" en  Evefant. Encuentra todo para tu próxima celebración aquí. Encuentra más de 4000 productos para tu próxima fiesta.`
    : "Busca entre nuestra amplia selección de productos para encontrar exactamente lo que necesitas.";

  return (
    <SEO title={title} description={description} type="website">
      {/* Add noindex to prevent search engines from indexing search results */}
      <meta name="robots" content="noindex, follow" />

      {/* Add canonical URL to avoid duplicating content */}
      <link rel="canonical" href={`${window.location.origin}/`} />

      {/* Add the search query as metadata */}
      <meta property="search:query" content={query} />

      {totalResults !== undefined && (
        <meta property="search:results" content={String(totalResults)} />
      )}

      {/* Add search-specific structured data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          url: window.location.origin,
          potentialAction: {
            "@type": "SearchAction",
            target: `${window.location.origin}/search?q={search_term_string}`,
            "query-input": "required name=search_term_string",
          },
        })}
      </script>
    </SEO>
  );
};

export default SearchSEO;
